import React from "react";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";
import {
  DoorGlassMaterial,
  getFramePositions,
  getFrameScaling,
} from "../../../../../shared/utils/door";
import { frameSettings } from "shared/utils/doorConfigurations";
import { PaneelGLTFResult } from "./PaneelType";

interface FrameProps extends frameSettings {
  doorNodes: PaneelGLTFResult["nodes"];
  materials: DoorGlassMaterial;
  index: number;
}

const Frame: React.FC<FrameProps> = ({
  doorNodes,
  materials,
  index,
  ...props
}: FrameProps) => {
  const {
    getConfigurationHeight,
    getConfigurationWidth,
    getConfigurationColor,
  } = useConfigurationOptionsContext();

  const height = getConfigurationHeight(index);
  const width = getConfigurationWidth(index);

  const positions = getFramePositions(width, height);
  const scaling = getFrameScaling(width, height);

  // TODO: Fix right and left part of frame (make sure the right positions can be used)
  const yPositionSides = -0.025 * (-1 * (1 - scaling.vertical.y));

  const xScalingMisc =
    scaling.horizontal.x +
    (1 - scaling.horizontal.x) * ((60 / width) * scaling.horizontal.x);

  return (
    <group dispose={null} rotation-y={Math.PI}>
      <mesh
        geometry={doorNodes["frame_bottom"].geometry}
        material={materials[getConfigurationColor()]}
        scale={[
          scaling.horizontal.x + 0.004,
          scaling.horizontal.y,
          scaling.horizontal.z,
        ]}
        position={positions.bottom}
      ></mesh>
      {props?.frameLeft?.enabled !== false && (
        <mesh
          geometry={doorNodes["frame_left"].geometry}
          material={materials[getConfigurationColor()]}
          scale={scaling.vertical}
          position={[positions.right.x, yPositionSides, 0]}
        ></mesh>
      )}
      <mesh
        geometry={doorNodes["frame_right"].geometry}
        material={materials[getConfigurationColor()]}
        scale={scaling.vertical}
        position={[positions.left.x, yPositionSides, 0]}
      ></mesh>
      <mesh
        geometry={doorNodes["frame_top"].geometry}
        material={materials[getConfigurationColor()]}
        scale={[
          scaling.horizontal.x + 0.0045,
          scaling.horizontal.y,
          scaling.horizontal.z,
        ]}
        position={positions.top}
      ></mesh>
      <mesh
        geometry={doorNodes["misc_0"].geometry}
        material={materials[getConfigurationColor()]}
        scale={[
          xScalingMisc + 0.046 + (props?.misc0?.scaleX ?? 0),
          1.144 + (props?.misc0?.scaleY ?? 0),
          1,
        ]}
        position={[
          positions.top.x + 0.0015 + (props?.misc0?.shiftX ?? 0),
          positions.top.y + (props?.misc0?.shiftY ?? 0),
          positions.top.z,
        ]}
      ></mesh>
      <mesh
        geometry={doorNodes["misc_1"].geometry}
        material={materials[getConfigurationColor()]}
        position-x={0.001}
        scale={[xScalingMisc + 0.046, 1.144, 1]}
      ></mesh>
    </group>
  );
};

export default Frame;
